import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
import { GoogleMap, LoadScript, Polygon } from "@react-google-maps/api";
import { useEffect } from "react";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowsRotate,
  faDotCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import LoadingIcon from "../../components/loading/LoadingIcon";
import {
  pageCountDecrease,
  pageCountIncrease,
} from "../../redux/app/map/map-slice";
import Modal from "../../components/b2b/Modal";
import { getToken } from "../../redux/app/auth/auth-slice";
import {
  setOpenDeleteModal,
  setRegionToBeDelete,
} from "../../redux/app/regions/region-slice";
import { Button, Tooltip } from "@mui/material";

const Regions = () => {
  const dispatch = useDispatch();
  const { regions, totalRegions, regionLoading, pageCount, isLoading } =
    useSelector((state) => state.map);
  const { token } = useSelector((state) => state.auth);

  // state
  const [regionNameInput, setregionNameInput] = useState();
  // useEffect(() => {
  //   dispatch({ type: "GET_FLAT_REGIONS", payload: { token } });
  // }, []);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      dispatch(getToken({ token: localStorage.getItem("token") }));
    }
  }, [token, dispatch]);

  // useEffect(() => {
  //   dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
  //   dispatch({ type: "GET_TOTAL_REGIONS" });
  // }, []);

  useEffect(() => {
    if (pageCount > 1) {
      dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
    }
  }, [pageCount]);

  // useEffect(() => {
  //   dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
  // }, [pageCount, dispatch]);

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  useEffect(() => {
    if (regionNameInput?.length > 2) {
      const regionTimer = setTimeout(() => {
        dispatch({
          type: "REGION_SEARCH",
          payload: {
            regionName: regionNameInput,
          },
        });
      }, 500);

      return () => clearTimeout(regionTimer);
    }

    if (regionNameInput?.length === 0) {
      dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
    }
  }, [regionNameInput, dispatch]);

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen mb-5">
          <div className="sm:flex items-center justify-between sm:space-x-10 px-6 py-2">
            {/* <div className="text-lg font-semibold text-primary">Regions</div> */}
            <div className="flex space-x-10 justify-start">
              <div className="flex items-center space-x-2">
                <div className="text-base text-gray-700">Total Regions:</div>
                <div className="text-lg font-semibold">
                  {" "}
                  {regions.length} / {totalRegions}
                </div>
              </div>

              <div className="flex space-x-4">
                <div>
                  <div className="text-sm font-semibold text-gray-700">
                    Search by region
                  </div>
                  <input
                    onChange={(e) => setregionNameInput(e.target.value)}
                    type="text"
                    className="border-b-2 focus:outline-none textField"
                    placeholder="Search"
                  />
                </div>

                {regionLoading && (
                  <div>
                    <LoadingIcon />
                  </div>
                )}
              </div>
            </div>
            <div className="w-1/2 sm:w-auto mt-3 sm:mt-0">
              <div></div>
              <Link to="/regions/create">
                <div className="flex px-2 py-2 space-x-2 text-sm tracking-wider text-white rounded-md cursor-pointer bg-secondary hover:bg-gray-300 hover:text-black">
                  <PlusIcon className="w-5" />
                  <div>Add New Region</div>
                </div>
              </Link>
            </div>
          </div>
          <div className="">
            <div className="flex space-x-3 pt-3 justify-between px-10">
              <div
                onClick={() => {
                  pageCount > 1 && dispatch(pageCountDecrease());
                }}
                className={`flex  space-x-2 items-center ${
                  pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                }  `}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleLeft}
                  className={`flex  space-x-2 items-center ${
                    pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                  }  `}
                />
                <div className="">Prev</div>
              </div>
              <div className="flex items-start space-x-2">
                <div className="text-lg ">Page:</div>
                <div className="text-lg font-semibold">
                  {pageCount} / {Math.ceil(totalRegions / 20)}
                </div>
              </div>

              <div
                onClick={() => {
                  pageCount < totalRegions / 20 &&
                    dispatch(pageCountIncrease());
                }}
                className={`flex space-x-2 items-center ${
                  pageCount < Math.ceil(totalRegions / 20)
                    ? "cursor-pointer"
                    : " text-gray-600"
                }  `}
              >
                <div>Next</div>
                <FontAwesomeIcon
                  icon={faArrowAltCircleRight}
                  className={`flex space-x-2 items-center ${
                    pageCount < Math.ceil(totalRegions / 20)
                      ? "cursor-pointer"
                      : " text-gray-600"
                  }  `}
                />
              </div>
            </div>
          </div>
          <div className="h-screen overflow-y-auto scrollbar">
            {!isLoading ? (
              <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 rounded-t">
                {regions?.map((item) => {
                  let x = 0;
                  let y = 0;
                  let z = 0;
                  let path = [];
                  let center;
                  item?.LocationPoints?.forEach((element) => {
                    path.push({
                      lat: element?.geometry?.location?.lat,
                      lng: element?.geometry?.location?.lng,
                    });
                  });

                  path?.forEach((element) => {
                    var latitude = (element?.lat * Math?.PI) / 180;
                    var longitude = (element?.lng * Math?.PI) / 180;

                    x += Math.cos(latitude) * Math.cos(longitude);
                    y += Math.cos(latitude) * Math.sin(longitude);
                    z += Math.sin(latitude);
                  });

                  var total = path?.length;

                  x = x / total;
                  y = y / total;
                  z = z / total;

                  var centralLongitude = Math.atan2(y, x);
                  var centralSquareRoot = Math.sqrt(x * x + y * y);
                  var centralLatitude = Math.atan2(z, centralSquareRoot);

                  center = {
                    lat: (centralLatitude * 180) / Math.PI,
                    lng: (centralLongitude * 180) / Math.PI,
                  };

                  return (
                    <>
                      <RegionItem
                        paths={path}
                        center={center}
                        regionname={item?.name}
                        regionId={item?._id}
                      />
                    </>
                  );
                })}
              </div>
            ) : (
              <>
                <div className="flex py-52 justify-center items-center">
                  <LoadingIcon />
                </div>
              </>
            )}
            <div className="my-36"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regions;

export const RegionItem = ({ paths, center, regionname, regionId }) => {
  const containerStyle = {
    width: "100%",
    height: "300px",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  };

  const options = {
    fillColor: "#39121739",
    fillOpacity: 1,
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };
  const dispatch = useDispatch();
  const deleteModalRef = useRef(false);
  // const [deleteRegionModal, setdeleteRegionModal] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const { openDeleteModal, RegionToBeDelete } = useSelector(
    (state) => state.region
  );

  const transferRegionToFlatRegion = (regionId) => {
    dispatch({
      type: "TRANSFER_REGION_TO_FLAT_REGION",
      payload: {
        id: regionId,
        token: token,
      },
    });
  };

  return (
    <>
      <div className="m-5">
        {openDeleteModal && (
          <>
            {/* <div className="fixed top-0 left-0 w-screen h-screen bg-red-100 bg-opacity-10 z-10 flex justify-center items-center"></div> */}
            <Modal
              addOnClick={() => {
                dispatch({
                  type: "DELETE_FLAT_REGION",
                  payload: {
                    id: RegionToBeDelete?.id,
                    token: token,
                  },
                });
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: false,
                  })
                );
              }}
              addButtonLabel="Yes"
              heading={`Delete ${RegionToBeDelete?.name}`}
              isDeleteRegion={true}
              cancelOnClick={() => {
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: false,
                  })
                );
              }}
            />
          </>
        )}
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={8}
          >
            {/* Child components, such as markers, info windows, etc. */}

            <Polygon
              // onLoad={onLoad}
              paths={paths}
              options={options}
            />
          </GoogleMap>
        </LoadScript>
        <div className="flex items-center justify-between px-3 py-1 mt-1 bg-gray-200 rounded-b-md">
          <div className="py-1 font-semibold text-center text-gray-700 text-md ">
            {regionname}
          </div>
          <div className="flex spacex-x-5 items-center">
            {/* <Tooltip title="Transfer to Flat Region">
              <Button
                onClick={() => {
                  transferRegionToFlatRegion(regionId);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
                  />
                </svg>
              </Button>
            </Tooltip> */}
            <Link to={`/regions/edit/${regionId}`}>
              <PencilIcon className="text-gray-700 cursor-pointer hover:bg-[#fb4156] rounded-full w-8 h-8 p-0.5 hover:text-gray-50 transition duration-300 ease-in-out" />
            </Link>
            <TrashIcon
              className="text-red-500 w-6 h-6 cursor-pointer"
              onClick={() => {
                dispatch(
                  setRegionToBeDelete({
                    id: regionId,
                    name: regionname,
                  })
                );
                //
                dispatch(
                  setOpenDeleteModal({
                    openDeleteModal: true,
                  })
                );
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
